import * as timex from "timex"

export default function DateNowFormatted() {
	let dt = timex.utc()
	return dt.toFormat("LLLL yyyy")
}
